import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=4e1fe59c"
import script from "./FileDownload.vue?vue&type=script&lang=ts"
export * from "./FileDownload.vue?vue&type=script&lang=ts"
import style0 from "./FileDownload.vue?vue&type=style&index=0&id=4e1fe59c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports